<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_7"></a><a id="ack"></a><em><strong>Acknowledgments</strong></em></h2>
<p class="noindent">A number of people played an important role in the development of this book. Steve Priebe’s horticultural knowledge and finesse in editing made the text much more understandable. The keen proofreading of Bill Ehrler caught many an error I would have overlooked. Jane Cole, librarian at the Desert Botanical Garden, was most helpful in tracking down information.</p>
<p class="indent">I am indebted to many botanists, horticulturists, and other landscape professionals throughout the Southwest for sharing with me their vast knowledge of native plants. Thank you to Bill Bourbon, Laura Bowden, Wally Camp, Mark Dimmitt, Ron Gass, Wendy Hodgson, John Hogan, Dan James, Matt Johnson, Joe McAuliffe, Sarah McCombs, Bill Murphy, Kent Newland, Donald Pinkava, Greg Starr, Jon Stewart, Jimmy Tipton, Tom Wilson, and Allan Zimmerman.</p>
<p class="indent">Rita Jo Anthony, W. D. Bransford, Norman G. Flaigg, Ron Gass, Charles Mann, the National Wildflower Research Center, Steve Priebe, and Benny Simpson generously provided photographs.</p>
<p class="indent">I owe a special thank you to Art Pizzo. In addition to using his artistic ability in creating the sketches, he helped me in so many other ways—making trips to photograph plants, doing research, and reviewing the text—but perhaps most important, always being there with encouragement and support.</p>
<p class="image"><img alt="image" src="html/images/f0007-01.jpg"/></p>
<p class="image1"><a id="page_8"></a><img alt="image" src="html/images/f0008-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292747364_06_ack.vue?42f117d8